'use es6';

import { formatDurationToUnit, getDefaultUnit } from '../../utilities/durationUtilities';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DisplayValueDuration = props => {
  const {
    value: duration
  } = props;
  const unit = getDefaultUnit(duration);
  const formattedDuration = formatDurationToUnit(duration, unit);
  const langKey = 'customerDataFilters.FilterOperatorDurationInput.DurationUnits.countAndUnit';
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `${langKey}.${unit}`,
    options: {
      count: formattedDuration
    }
  });
};
DisplayValueDuration.propTypes = {
  value: PropTypes.number.isRequired
};
export default /*#__PURE__*/memo(DisplayValueDuration);